var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag5Fr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#57A863;}\n\t.st2{fill:#00209F;}\n\t.st3{fill:#F32840;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy",
    className: "st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64,5.3v31.4c0-0.1,0-0.3,0-0.4V5.7C64,5.6,64,5.5,64,5.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.8,42h15.5V0H5.8C2.6,0,0,2.6,0,5.7v30.7C0,39.5,2.6,42.1,5.8,42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.2,42H42.7V0h15.5C61.4,0,64,2.6,64,5.7v30.7C64,39.5,61.4,42.1,58.2,42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag5Fr);
export default __webpack_public_path__ + "static/media/flag_5_FR.2e53a97cf368caa234afbb2905bb2763.svg";
export { ForwardRef as ReactComponent };